var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery4Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.1,1040c-15,0-25-5-35-15c-10-10-15-20-15-35V190c0-15,5-25,15-35c10-10,20-15,35-15h100V90c0-15,5-25,15-35 c10-10,20-15,35-15h100c15,0,25,5,35,15s15,20,15,35v50h100c15,0,25,5,35,15s15,20,15,35v350c-85,0-155,30-210,90 c-60,60-90,130-90,210c0,40,5,75,20,110c15,35,30,65,55,90H278.1z M328.1,440h300V240h-300V440z M623.1,890c-10,0-15-5-20-15 c-5-10-5-15,0-25l125-180c5-5,10-5,15-5c5,0,10,5,10,10v110h75c10,0,15,5,20,15c5,10,5,15,0,25l-125,180c-5,5-10,5-15,5s-10-5-10-10 V890H623.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery4Black);
export default __webpack_public_path__ + "static/media/battery-4-black.5a4eb87805fa6dd681028af577a53b74.svg";
export { ForwardRef as ReactComponent };